// src/components/common/DebugInfo.jsx
import React from "react";
import { Box, Paper, Typography, Chip, Stack } from "@mui/material";
import { useSelector } from "react-redux";

const DebugInfo = () => {
  const { isAuthenticated, user, loading, error } = useSelector(
    (state) => state.auth,
  );

  return (
    <Paper sx={{ p: 2, m: 2, bgcolor: "#f5f5f5" }}>
      <Typography variant="h6" gutterBottom>
        🔍 Debug Information
      </Typography>
      <Stack spacing={1}>
        <Box>
          <Chip
            label={`Authenticated: ${isAuthenticated ? "✅ Yes" : "❌ No"}`}
            color={isAuthenticated ? "success" : "error"}
          />
        </Box>
        <Box>
          <Chip
            label={`Loading: ${loading ? "⏳ Yes" : "✅ No"}`}
            color={loading ? "warning" : "success"}
          />
        </Box>
        {user && (
          <Box>
            <Typography variant="body2">
              User: {user.displayName || user.email}
            </Typography>
          </Box>
        )}
        {error && (
          <Box>
            <Typography variant="body2" color="error">
              Error: {error}
            </Typography>
          </Box>
        )}
        <Box>
          <Typography variant="body2">
            LocalStorage token:{" "}
            {localStorage.getItem("token") ? "✅ Present" : "❌ Missing"}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            LocalStorage user:{" "}
            {localStorage.getItem("user") ? "✅ Present" : "❌ Missing"}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

export default DebugInfo;
